import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { useNavigate } from "react-router-dom";
import { LOCALES } from '../../i18n';
import { actionChangeLanguage, actionToggleSideBarMobile } from '../../store/action/LayoutActionSupervisor'
import { userLogout } from "./FirebaseSupervisor";
import translate from "../../i18n/translate";
import { isLoginSupervisorAccessRightsLoaded, actionGetSupervisorProfile } from "../../store/action/RemoteActionSupervisor";

const NavbarSupervisor = (props) => {
    const [email, setEmail] = useState("");
    const [supervisorName, setSupervisorName] = useState("");
    const [sidebarVisible, setSidebarVisible] = useState(true);
    const [isAccessRightsLoaded, setIsAccessRightsLoaded] = useState(false);
    const navigate = useNavigate();

    const toggleMobile = (e) => {
        setSidebarVisible(!sidebarVisible);
        props.actionToggleSideBarMobile(sidebarVisible);
    }

    const handleLogout = async () => {
        await userLogout(1);
    };

    useEffect(() => {
        if (props?.supervisor?.length > 0) {
            setEmail(props?.supervisor[0].MailID);
            setSupervisorName(props?.supervisor[0].FirstName + ' ' + props?.supervisor[0].LastName);
        }
    }, [props.supervisor]);

    useEffect(() => {
        if (isLoginSupervisorAccessRightsLoaded()) {
            setIsAccessRightsLoaded(true);
        }
        props.actionGetSupervisorProfile();
    }, []);

    return (props?.supervisor?.length > 0) ? (
        <div className="topbar">
            <div className="topbar-md d-lg-none">
                <div className="container">
                    <div className="d-flex align-items-center justify-content-between">
                        <a href="#" className="toggle-nav" onClick={toggleMobile}>
                            <div className="toggle-icon">
                                <span className="toggle-line" />
                                <span className="toggle-line" />
                                <span className="toggle-line" />
                                <span className="toggle-line" />
                            </div>
                        </a>
                        {/* .toggle-nav */}
                        <div className="site-logo">
                            <a href="/" className="site-brand">
                                <img
                                    src={require(`../../assets/images/logo_supervisor.PNG`)}
                                    style={{ width: 50, height: 50 }}
                                    alt="logo"
                                    srcSet={require(`../../assets/images/logo_supervisor.PNG`)}
                                />
                            </a>
                        </div>
                        {/* .site-logo */}
                        <div className="dropdown topbar-action-item topbar-action-user">
                            <a href="/" data-bs-toggle="dropdown">
                                <img
                                    className="icon"
                                    src={require('../../assets/images/user-thumb-sm.png')}
                                    alt="thumb"
                                />
                            </a>
                            <div className="dropdown-menu dropdown-menu-end">
                                <div className="user-dropdown">
                                    <div className="user-dropdown-head">
                                        <h6 className="user-dropdown-name">
                                            <span>{supervisorName}</span>
                                        </h6>
                                        <span className="user-dropdown-email">
                                            {email}
                                        </span>
                                    </div>
                                    <ul className="user-dropdown-links">
                                        <li>
                                            <a href="#" onClick={() => handleLogout()}>
                                                <i className="ti ti-power-off" />
                                                {translate('Logout')}
                                            </a>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                        {/* .toggle-action */}
                    </div>
                    {/* .container */}
                </div>
                {/* .container */}
            </div>
            {/* .topbar-md */}
            <div className="container">
                <div className="d-lg-flex align-items-center justify-content-between">
                    <div className="topbar-lg d-none d-lg-block">
                        <div className="site-logo">
                            <a href="/" className="site-brand">
                                <img
                                    src={require(`../../assets/images/logo_supervisor.PNG`)}
                                    style={{ width: 50, height: 50 }}
                                    alt="logo"
                                    srcSet={require(`../../assets/images/logo_supervisor.PNG`)}
                                />
                            </a>
                        </div>
                        {/* .site-logo */}
                    </div>
                    {/* .topbar-lg */}
                    <div className="topbar-action d-none d-lg-block">
                        <ul className="topbar-action-list">
                            {isAccessRightsLoaded &&
                                <li className="topbar-action-item topbar-action-link">
                                    <a href="/dashboard">
                                        <em className="ti ti-home" /> {translate('Home')}
                                    </a>
                                </li>
                            }
                            {/* .topbar-action-item */}
                            <li className="dropdown topbar-action-item topbar-action-language">
                                <a href="/" data-bs-toggle="dropdown">
                                    {" "}
                                    {props.locale === 'en-us' ? 'EN' : 'JP'} <em className="ti ti-angle-down" />{" "}
                                </a>
                                <ul className="dropdown-menu">
                                    <li>
                                        <a href="/" onClick={(e) => {
                                            e.preventDefault();
                                            props.actionChangeLanguage(LOCALES.JAPANESE);
                                        }}>JP</a>
                                    </li>
                                    <li>
                                        <a href="/" onClick={(e) => {
                                            e.preventDefault();
                                            props.actionChangeLanguage(LOCALES.ENGLISH);
                                        }}>EN</a>
                                    </li>
                                </ul>
                            </li>
                            {/* .topbar-action-item */}
                            <li className="dropdown topbar-action-item topbar-action-user">
                                <a href="/" data-bs-toggle="dropdown">
                                    {" "}
                                    <img
                                        className="icon"
                                        src={require('../../assets/images/user-thumb-sm.png')}
                                        alt="thumb"
                                    />{" "}
                                </a>
                                <div className="dropdown-menu dropdown-menu-end">
                                    <div className="user-dropdown">
                                        <ul className="user-dropdown-links">
                                            <li>
                                                <a href="#" onClick={() => handleLogout()}>
                                                    <i className="ti ti-power-off" />
                                                    {translate('Logout')}
                                                </a>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </li>
                            {/* .topbar-action-item */}
                        </ul>
                        {/* .topbar-action-list */}
                    </div>
                    {/* .topbar-action */}
                </div>
                {/* .d-flex */}
            </div>
            {/* .container */}
        </div>
    ) : "";
};

const mapStateToProps = state => {
    return {
        locale: state.siteLayout.locale,
        sideBarMobile: state.siteLayout.sideBarMobile,
        supervisor: state.remote.supervisor,
        supervisorError: state.remote.supervisorError
    };
};

export default connect(mapStateToProps, {
    actionChangeLanguage,
    actionToggleSideBarMobile,
    actionGetSupervisorProfile
})(NavbarSupervisor);
